module.exports = "<footer>\n    <div class=\"container\">\n        <img src=\"assets/img/logo.png\" alt=\"\" class=\"logo\">\n        <!-- <ul class=\"social\">\n            <li class=\"wechat\"><a (click)=\"wechatClick()\"><img src=\"assets/img/we.png\" alt=\"\"></a></li>\n        </ul> -->\n        <p class=\"copyright\">© Overhand Technology Limited</p>\n    </div>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = ./src/app/components/footer/footer.component.html
// module chunks = main